import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Disabled, DisabledButton } from "../../../../Constant";
import { DISABLE_BUTTONS_LIST, DISABLE_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn } from "../../../../AbstractElements";
import CommonButton from "../Common/CommonButton";

const DisabledButtons = () => {
  return (
    <Card>
      <CommonCardHeader title={DisabledButton} span={DISABLE_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn disabled color="primary">{Disabled}</Btn>
        {DISABLE_BUTTONS_LIST.map((data, index) => (
          <CommonButton key={index} item={data} disabled={true} />
        ))}
      </CardBody>
    </Card>
  );
};

export default DisabledButtons;
